'use client';

import React, { useEffect, useState } from 'react';
import { calculateTimeAgo, renderToHuman } from '@repo/time-ago';
import type { ProjectWithAllRelations } from '@repo/database';

export default function LastUpdate({
  project,
}: {
  project: ProjectWithAllRelations;
}): React.JSX.Element {
  const [projectUpdated, setProjectUpdated] = useState<string>();
  useEffect(() => {
    const today = new Date();
    const updatedAt = project.jarsStats.updatedAt;
    const timeDiff = today.getTime() - updatedAt.getTime();
    const timeOpenedAgo = calculateTimeAgo(timeDiff);
    const timeOpenedAgoLabel = renderToHuman(timeOpenedAgo);

    setProjectUpdated(`${timeOpenedAgo.value} ${timeOpenedAgoLabel}`);
  }, [project.jarsStats.updatedAt]);

  return (
    <p title={project.jarsStats.updatedAt.toLocaleString()}>
      Дані оновлено: <span className='font-medium'>{projectUpdated} тому</span>
    </p>
  );
}
